import { neutral } from 'shared/styles/colors';

export const SHIMMER_GRADIENT = `linear-gradient(90deg, ${neutral[20]} 25%, ${neutral[10]} 50%, ${neutral[20]} 75%)`;

export const shimmerKeyframes = {
  '@keyframes shimmer': {
    '0%': { backgroundPosition: '200% 0' },
    '100%': { backgroundPosition: '-200% 0' },
  },
} as const;
